:host{width:100%}
/*# sourceMappingURL=naked-output.component.css.map */
